import { render, staticRenderFns } from "./closeRequestModal.vue?vue&type=template&id=74623e5c&scoped=true&"
import script from "./closeRequestModal.vue?vue&type=script&lang=js&"
export * from "./closeRequestModal.vue?vue&type=script&lang=js&"
import style0 from "./closeRequestModal.vue?vue&type=style&index=0&id=74623e5c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74623e5c",
  null
  
)

export default component.exports